import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import OperationWithPrimaryContact from '@/types/Operation/OperationWithPrimaryContact';

import Operation from '../../../types/Operation/Operation';

export type OperationsState = {
  entries: Operation[];
};

const initialState: OperationsState = {
  entries: []
};

export const operationsSlice = createSlice({
  name: 'operations',
  initialState,
  reducers: {
    addAllOperations(state, action: PayloadAction<Operation[]>) {
      state.entries = action.payload;
    },

    newOperation(state, action: PayloadAction<OperationWithPrimaryContact>) {
      const { primaryContact, ...newOperation } = action.payload;
      state.entries.push(newOperation);
    },

    updateOperation(state, action: PayloadAction<{ operation: Operation; name: string }>) {
      const index = state.entries.findIndex(entry => entry.name === action.payload.name);
      if (index !== -1) {
        state.entries[index] = action.payload.operation;
      }
    },

    updateStarredOperation(state, action: PayloadAction<{ name: string; starred: boolean }>) {
      const index = state.entries.findIndex(entry => entry.name === action.payload.name);
      if (index !== -1) {
        state.entries[index].starred = action.payload.starred;
      }
    },

    removeOperation(state, action: PayloadAction<string>) {
      const index = state.entries.findIndex(entry => entry.name === action.payload);
      if (index !== -1) {
        state.entries.splice(index, 1);
      }
    }
  }
});

export const {
  addAllOperations,
  newOperation,
  updateOperation,
  updateStarredOperation,
  removeOperation
} = operationsSlice.actions;

export default operationsSlice.reducer;
